import Component from 'gia/Component';

import { gsap } from "gsap";

import { TextPlugin } from "gsap/TextPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export default class SideMenu extends Component {
  constructor(element) {
    super(element);
    this.ref = {

    }
  }

  mount() {
    let tl = gsap.timeline({
      repeat: -1, yoyo: true
    });
    tl.to(this.element, {
      color: '#f97373',
      duration:2
    },"+=2");
    tl.to(this.element, {
      color: '#ffb600',
      duration:2
    },"+=2");
    tl.to(this.element, {
      color: '#aaa1f8',
      duration:2
    },"+=2");
    tl.to(this.element, {
      color: '#1b4134',
      duration:2
    },"+=2");
  }


}